import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[0.692em] font-bold whitespace-nowrap border',
  {
    variants: {
      variant: {
        ok:   'bg-(--color-green-bg) text-(--color-green) border-(--color-green)/30',
        warn: 'bg-(--color-amber-bg) text-(--color-amber) border-(--color-amber)/30',
        crit: 'bg-(--color-red-bg)   text-(--color-red)   border-(--color-red)/30',
        info: 'bg-(--color-blue-bg)  text-(--color-blue)  border-(--color-blue)/30',
        muted:'bg-(--color-bg)       text-(--color-text3) border-(--color-border)',
        solid:'bg-(--color-blue)     text-(--color-on-accent)          border-(--color-blue)',
        // Mockup `.badge-3rdparty` — the purple "Partner" tag on external assets.
        partner:'bg-(--color-purple)/12 text-(--color-purple) border-(--color-purple)/25',
      },
    },
    defaultVariants: { variant: 'ok' },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant, className }))} {...props} />;
}
